export default __webpack_public_path__ + "static/media/p3-11.d3d80b03.png";